export default __webpack_public_path__ + "697729eaf810853bfbd7af7bb5c276f2.svg";